import React from 'react';
import { useParams } from 'react-router';
import { Route, Switch } from 'react-router-dom';

import { If } from 'app/components/if';
import { useEntityResolver2, useCallbackOnProdSwitch } from 'app/hooks';
import { brandService } from 'app/services/brand.service';
import { BrandDeletion } from 'features/cris/brands/brand-deletion';
import { BrandForm } from 'features/cris/brands/brand-form';

import { BrandDetails } from './brand-details';

export const BrandRouter: React.FunctionComponent = () => {
    const { id } = useParams<{ id: string }>();
    const { entity: brand, reload } = useEntityResolver2(brandService, id);
    useCallbackOnProdSwitch(reload);

    return (
        <Switch>
            <Route exact path='/cris/brands/:id/details'>
                <If condition={undefined !== brand}>
                    <BrandDetails brand={brand!} />
                </If>
            </Route>
            <Route exact path='/cris/brands/:id'>
                <BrandForm />
            </Route>

            <Route exact path='/cris/brands/:id/delete'>
                {brand?.id !== undefined ? <BrandDeletion brand={brand} /> : 'Invalid Brand'}
            </Route>
        </Switch>
    );
};
